import { render, staticRenderFns } from "./ExpensesAddEdit.vue?vue&type=template&id=0e608a7b&scoped=true"
import script from "./ExpensesAddEdit.vue?vue&type=script&lang=js"
export * from "./ExpensesAddEdit.vue?vue&type=script&lang=js"
import style0 from "./ExpensesAddEdit.vue?vue&type=style&index=0&id=0e608a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e608a7b",
  null
  
)

export default component.exports